import { eHinhThucTinhActionsObj } from "../../action-types/mien-giam/IHinhThucTinhActions";
import { generateActions } from "../generateActions";

export const hinhThucTinhActions = {
  ...generateActions(eHinhThucTinhActionsObj, "HINH_THUC_TINH_MIEN_GIAM"),
};
